import PropTypes from 'prop-types';
import { addAislesToColumnDetails, addAislesToRows, addExitRows, isEmptyRow, isExitRow, isRowOverWing } from '../utils/layout';
import ColumnDetails from './rows/ColumnDetails';
import Row from './rows/Row';
import RowContent from './rows/RowContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const generateKey = index => `row_${index}`;
const SeatMapCabin = _ref => {
  let {
    activeSegment,
    activeTraveler,
    carrier,
    sellSeatMapColumnDetails = [],
    onChange,
    rows = [],
    travelers
  } = _ref;
  const columnsWithAisles = addAislesToColumnDetails(sellSeatMapColumnDetails);
  const rowsWithAisles = addAislesToRows(rows, columnsWithAisles);
  const transformedRowData = addExitRows(rowsWithAisles);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ColumnDetails, {
      details: columnsWithAisles,
      isOverWing: isRowOverWing(transformedRowData[0])
    }), transformedRowData.map((row, index) => /*#__PURE__*/_jsx(Row, {
      isEmptyRow: isEmptyRow(row),
      isOverWing: isRowOverWing(row),
      children: /*#__PURE__*/_jsx(RowContent, {
        ...row,
        activeSegment: activeSegment,
        activeTraveler: activeTraveler,
        carrier: carrier,
        isEmptyRow: isEmptyRow(row),
        isExitRow: isExitRow(row),
        onChange: onChange,
        travelers: travelers
      })
    }, generateKey(index)))]
  });
};
SeatMapCabin.propTypes = {
  activeSegment: PropTypes.string,
  activeTraveler: PropTypes.number,
  carrier: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string
  }),
  onChange: PropTypes.func,
  rows: PropTypes.arrayOf(PropTypes.shape({
    characteristics: PropTypes.arrayOf(PropTypes.string),
    rowNumber: PropTypes.number,
    sellSeatMapSeats: PropTypes.arrayOf(PropTypes.shape({
      column: PropTypes.string,
      isBookable: PropTypes.bool,
      price: PropTypes.number,
      row: PropTypes.number,
      seat: PropTypes.string,
      type: PropTypes.string
    }))
  })),
  sellSeatMapColumnDetails: PropTypes.arrayOf(PropTypes.shape({
    columnName: PropTypes.string,
    type: PropTypes.string
  })),
  travelers: PropTypes.arrayOf(PropTypes.shape({
    ageType: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string
  }))
};
export default SeatMapCabin;
//# sourceMappingURL=SeatMapCabin.js.map